<template>
    <div>
        <div class="civiichat-form-container">
            <div>
                <p class="civiichat-data-usage">{{feedbackMessage}}</p>
            </div>
            <div style="display:flex">
                <div class="feedback-icon-container" @click="giveFeedback(index + 1)" v-for="(icon, index) in feedbackIcons" :key="index">
                    <span v-html="icon"></span>
                </div>
                
            </div>
            <div class="civiichat-form-group">
                <label :disabled="blockInputs" class="civiichat-form-label">Email:</label>
                <input :disabled="blockInputs" class="civiichat-form-control" v-model="email">
            </div>
            <div v-if="showFormError">
                <p>{{formErrorMessage}}</p>
            </div>
            <div class="civiichat-form-group">
                <div class="civiichat-button-container">
                    <button :disabled="blockInputs" class="civiichat-form-button" @click="onSendHandler">Enviar</button>
                </div>
                <div class="civiichat-button-container">
                    <button :disabled="blockInputs" class="civiichat-form-button" @click="onDownloadHandler">Descargar</button>
                </div>   
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    props: {
        conversationData: {
            type: [Object]
        },
        endTime: {
            type: [Number]
        }
    },
    data: function(){
        return {
            conversation: {
                id: null,
            },
            feedbackIcons: [
                '&#128512;',
                '&#128512;',
                '&#128512;',
                '&#128512;',
                '&#128512;'
            ],
            email: '',
            feedbackValue: 0,
            feedbackMessage: '',
            showFormError: false,
            formErrorMessage: 'error formulario',
            blockInputs: false
        }
    },
    methods: {
        ...mapMutations(['addMessage', 'setDisableInput']),
        onSendHandler(){
            // logica para mandar correo con conversacion;
        },
        onDownloadHandler(){
            // logica para guardar conversacion en dispositivo;
        },
        giveFeedback(value) {
            this.feedbackValue = value;
        }
    },
    created(){
        if( ((this.endTime || 0) + 5000) < new Date().getTime()){
            this.blockInputs = true;
        } else {
            this.setDisableInput(true);
            setTimeout( () => {
                this.setDisableInput(false);
                this.addMessage({
                    type: 'Normal',
                    side: 'left',
                    messages: [
                        { text: window.civiiConf.civiiChat.goodbyeMessage }
                    ]
                });
            }, 5000);
        }
        this.feedbackMessage = window.civiiConf.civiiChat.feedbackMessage;
    }
}
</script>

<style>
    .feedback-icon-container {
        width: 20%;
        justify-content: center;
        display: flex;
    }
</style>


// WEBPACK FOOTER //
// src/civii-chat/components/CiviiChatFeedback.vue